module.exports = __webpack_public_path__ + "media/images/riders/BROOK_MACDONALD-f333ff4a69ef53c2823c85b32f2dc7d8.png";